<template>
  <div>
    <div class="two-title">
      <span v-for="(item, index) in titleData2" :key="index" @click="handleSort(index)" class="sort-header">
        {{ item }}
        <i v-if="sortIndex === index" :class="['icon', 'iconfont', 'sort-icon', sortOrder === 'asc' ? 'icon-icon--' : 'icon-icon--1']"></i>
      </span>
    </div>
    <ul class="order_content">
      <li
        @click="linkDeatil(item)"
        @touchstart="onPressStart($event, item)"
        @touchmove="onPressMove($event)"
        @touchend="onPressEnd"
        @touchcancel="onPressEnd"
        @mousedown="onPressStart($event, item)"
        @mousemove="onPressMove($event)"
        @mouseup="onPressEnd"
        @mouseleave="onPressEnd"
        v-for="(item, index) in arrData"
        :key="item.targetId || index"
      >
        <span class="targetId" v-fit-text>{{ getTarget(item) }}</span>
        <span :class="{ 'latestPrice-up': Number(item.latestPrice) > Number(item.lastSettlementPrice), 'latestPrice-down': Number(item.latestPrice) < Number(item.lastSettlementPrice) }">{{
          item.latestPrice
        }}</span>
        <span>{{ item.volume }}</span>
        <span>
          <i
            @click="changeShowData"
            :class="{
              'background-grey': Number(item.latestPrice) == Number(item.lastSettlementPrice),
              'background-red': Number(item.latestPrice) > Number(item.lastSettlementPrice),
              'background-green': Number(item.latestPrice) < Number(item.lastSettlementPrice),
            }"
            class="li-three-span"
          >
            {{ percent ? item.rangeRate : item.range }}</i
          >
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "tradeList",
  props: ["contentData"],
  data() {
    return {
      titleData2: ["合约", "最新价", "成交量", "涨跌幅"],
      percent: true,
      sortIndex: -1,
      sortOrder: "desc", // 'asc' or 'desc'
      pressTimer: null,
      pressStartX: 0,
      pressStartY: 0,
      suppressClick: false,
    };
  },
  computed: {
    arrData: function () {
      var arrDatas = [];
      for (const i of this.contentData) {
        if (i.lastSettlementPrice == 0) {
          var temporary = "0.00%";
        } else {
          var temporary = (((i.latestPrice - i.lastSettlementPrice) * 100) / i.lastSettlementPrice).toFixed(2) + "%";
        }
        arrDatas.push({
          lastSettlementPrice: i.lastSettlementPrice,
          latestPrice: i.latestPrice,
          targetId: i.targetId,
          targetName: i.targetName,
          volume: i.volume,
          rangeRate: temporary,
          range: i.latestPrice - i.lastSettlementPrice > 0 ? "+" + (i.latestPrice - i.lastSettlementPrice).toFixed(0) : (i.latestPrice - i.lastSettlementPrice).toFixed(0),
          rangeValue: i.latestPrice - i.lastSettlementPrice, // 用于排序
        });
      }

      // 排序逻辑
      if (this.sortIndex !== -1) {
        arrDatas.sort((a, b) => {
          let valA, valB;
          switch (this.sortIndex) {
            case 0: // 合约
              valA = a.targetId;
              valB = b.targetId;
              break;
            case 1: // 最新价
              valA = Number(a.latestPrice);
              valB = Number(b.latestPrice);
              break;
            case 2: // 成交量
              valA = Number(a.volume);
              valB = Number(b.volume);
              break;
            case 3: // 涨跌幅
            if (a.lastSettlementPrice == 0 || b.lastSettlementPrice == 0) {
              valA = a.rangeValue;
              valB = b.rangeValue;
            } else {
              valA = (a.latestPrice - a.lastSettlementPrice) / a.lastSettlementPrice;
              valB = (b.latestPrice - b.lastSettlementPrice) / b.lastSettlementPrice;
            }
            break;
          }

          if (this.sortOrder === "asc") {
            return valA > valB ? 1 : -1;
          } else {
            return valA < valB ? 1 : -1;
          }
        });
      }

      return arrDatas;
    },
  },
  mounted() {
    // console.log(this.arrData);
  },
  methods: {
    getPoint(e) {
      const touch = e && e.touches && e.touches[0];
      const changed = e && e.changedTouches && e.changedTouches[0];
      const point = touch || changed || e || {};
      return {
        clientX: point.clientX || 0,
        clientY: point.clientY || 0,
      };
    },
    clearPressTimer() {
      if (this.pressTimer) {
        clearTimeout(this.pressTimer);
        this.pressTimer = null;
      }
    },
    onPressStart(e, item) {
      this.clearPressTimer();
      const p = this.getPoint(e);
      this.pressStartX = p.clientX;
      this.pressStartY = p.clientY;
      this.pressTimer = setTimeout(() => {
        this.pressTimer = null;
        this.suppressClick = true;
        this.$emit("longpress", { event: e, item });
        setTimeout(() => {
          this.suppressClick = false;
        }, 450);
      }, 550);
    },
    onPressMove(e) {
      if (!this.pressTimer) return;
      const p = this.getPoint(e);
      if (Math.abs(p.clientX - this.pressStartX) > 10 || Math.abs(p.clientY - this.pressStartY) > 10) {
        this.clearPressTimer();
      }
    },
    onPressEnd() {
      this.clearPressTimer();
    },
    getTarget(item) {
      // return item.targetName.length <= 7 ? item.targetName : item.targetId;
      return item.targetName;
    },
    linkDeatil(item) {
      if (this.suppressClick) return;
      // this.$router.push({path:'/marketDetail/'+contract});
      this.$router.push({ path: "/marketDetail/" + item.targetId });
      // this.$router.push({path:'/marketDeatil'});
    },
    changeShowData(e) {
      e.stopPropagation();
      this.percent = !this.percent;
      if (this.percent == true) {
        this.titleData2[3] = "涨跌幅";
      } else if (this.percent == false) {
        this.titleData2[3] = "涨跌";
      }
    },
    handleSort(index) {
      if (this.sortIndex === index) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortIndex = index;
        this.sortOrder = "desc";
      }
    },
  },
};
</script>

<style scoped>
.two-title {
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  font-size: 0.3rem;
  color: #dbe3ec;
  background: linear-gradient(180deg, #1b2128 0%, #141a20 100%);
  display: flex;
  justify-content: center;
  flex-direction: row;
  position: absolute;
  top: 1rem;
  z-index: 10;
  border-bottom: 1px solid rgba(45, 56, 68, 0.9);
  box-shadow: 0 0.04rem 0.12rem rgba(0, 0, 0, 0.12);
}

.two-title span {
  flex: 1 1 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  white-space: nowrap;
  padding: 0 0.15rem;
  box-sizing: border-box;
  min-width: 0;
  color: #b7c3d0;
  font-weight: 600;
  letter-spacing: 0.01rem;
}

ul {
  width: 7.5rem;
  background: #11161c;
}

li {
  min-height: 1.02rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  font-size: 0.28rem;
  color: #b8c4cf;
  position: relative;
  background: transparent;
}

li span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 0;
  text-align: center;
  overflow: hidden;
  min-width: 0;
  white-space: nowrap;
  padding: 0 0.2rem;
  box-sizing: border-box;
}

.order_content {
  width: 100%;
  position: absolute;
  top: 2rem;
  bottom: 1rem;
  overflow: scroll;

  margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);
  margin-top: constant(safe-area-inset-top);
  margin-top: env(safe-area-inset-top);
}

.targetId {
  justify-content: flex-start;
  color: #f2d07a;
  font-weight: 500;
  padding-left: 0.22rem;
}

.latestPrice-up {
  color: #ff5b6a;
  font-weight: 600;
}

.latestPrice-down {
  color: #2acb7a;
  font-weight: 600;
}

.background-grey {
  background: linear-gradient(180deg, #6b7684 0%, #5c6673 100%);
}

.background-red {
  background: linear-gradient(180deg, #ff5f6d 0%, #f6465d 100%);
}

.background-green {
  background: linear-gradient(180deg, #26c281 0%, #18a96c 100%);
}

.sort-icon {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.2rem;
  color: #d8b830;
  padding: 0; /* 覆盖全局 iconfont 的 padding */
  float: none; /* 覆盖全局 iconfont 的 float */
}

.sort-icon.up {
  /* 可以添加向上箭头的特殊样式 */
}

.sort-icon.down {
  /* 可以添加向下箭头的特殊样式 */
}

.li-three-span {
  min-width: 1.18rem;
  padding: 0 0.12rem;
  border-radius: 0.08rem;
  height: 0.58rem;
  text-align: center;
  display: inline-block;
  font-style: normal;
  line-height: 0.58rem;
  color: #fff;
  font-weight: 700;
  letter-spacing: -0.01rem;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.06);
}

.sort-header .sort-icon {
  margin-left: 0.06rem;
  font-size: 0.22rem;
  color: #f5c156;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tradeList.vue